<style type="text/css" media="screen">
.active-tab{
	color:#08fdd8 !important;

}
.tab{
	color:grey !important;
	text-decoration: none;
}
.drawer-logo{
	margin-top: 20px;
	margin-bottom: 5px;
	height: 70px;
	/*width:;*/
}
.drawer-icons{
	height: 14px;
	width: 14px;
}
.drawer-text{
	font-family: Nunito Sans;
	font-style: normal;
	font-weight: 600;	
	font-size: 14px !important;
	line-height: 19px;
	align-items: center;
	color: #9C9C9C;
}
.active-tab{
	color: #1DC895 !important;
}


.drawer_list .v-list-item--link::before
{
	background-color: transparent !important;
}
.drawer_list .v-list-item--active .drawer-text{
	color:#1DC895 !important;
}

.warehouse-select{
	font-size: 12px !important
}
.v-expansion-panel-content__wrap{
	padding:0px !important;
}

</style>

<template>
	<div>
		
		<v-navigation-drawer color="linear-gradient(180deg, #003399 0%, #4066B3 100%)" app  v-model="$store.state.drawer.primary_drawer"  width="170" disable-resize-watcher  >
			<div class="text-center">
				<img src="@/assets/logo/logo.png" class="drawer-logo" />

			</div>
			<div class="px-2" v-if="$store.state.user_type==$keys.SUPER_ADMIN">
				<v-select
				v-model="warehouse"
				:items="warehouse_list"
				item-text="name"
				item-value="id"
				label="Select"
				persistent-hint
				return-object
				single-line
				outlined
				dense
				@focus="warehouseAutoComplete"
				class="warehouse-select"
				:rules="$rules.WAREHOUSE"
				:loading="loading"	
				@change="updateWarehouse"
				>
				<template v-slot:item="data">
					<v-list-item-content>
						<v-list-item-title v-html="data.item.name"></v-list-item-title>
						<v-list-item-subtitle >{{data.item.city}},{{data.item.state}}</v-list-item-subtitle>
					</v-list-item-content>
				</template>
			</v-select>
		</div>


		<v-list dense nav class="pa-0 drawer_list">
			<div v-for="(item, i) in getDrawerItems" :key="i" class="">
				<v-list-item link :to="item.url" @click="setActiveTab(item)" class="border-b py-1" :class="i==0?'border-t':''"   
				v-if="item.access_by.includes($store.state.user_type) && item.title!='Manage'" >
				<v-list-item-icon class="my-3 mx-2">
					<img :src="item.is_active_tab?item.src_active:item.src" alt="">
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title class="drawer-text">
						<!-- <a class="drawer-text"> -->
							{{ item.title }}
							<!-- </a> -->
						</v-list-item-title>

					</v-list-item-content>
				</v-list-item>
			</div>

			<v-list-item link :to="getManageTab.url" @click="setActiveTab(getManageTab)" class="border-b py-1 large-screen border-t l" 
			v-if="getManageTab.access_by.includes($store.state.user_type)">
			<v-list-item-icon class="my-3 mx-2">
				<img :src="getManageTab.is_active_tab?getManageTab.src_active:getManageTab.src" alt="">
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title class="drawer-text">
					{{ getManageTab.title }}
				</v-list-item-title>

			</v-list-item-content>
		</v-list-item>

		<v-expansion-panels accordion flat class="border-b px-3 small-screen" multiple :disabled="false" v-if="getManageTab.access_by.includes($store.state.user_type)">
			<v-expansion-panel class="bg-transparent">
				<v-expansion-panel-header class="px-0 drawer-text">{{ getManageTab.title }}</v-expansion-panel-header>
				<v-expansion-panel-content class="mt-0 px-0">

					<v-list dense nav class="pa-0 drawer_list bg-transparent ">
						<div v-for="(item, i) in getSubDrawerItems" :key="i" class="">
							<v-list-item   link :to="item.url" v-if="item.access_by.includes($store.state.user_type)" class="border-b py-1" >
								<v-list-item-content  class="drawer-text my-1">
									{{ item.title }}
								</v-list-item-content>
							</v-list-item>
						</div>
					</v-list>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>



		<v-list-item link @click="logout" >
			<v-list-item-content>
				<div class="text-center">
					<img src="@/assets/drawer/logout.svg" alt="">
					<p class="text-center drawer-text">
						{{ $lang.LOGOUT }}
					</p>
				</div>
			</v-list-item-content>
		</v-list-item>
		<!--  super admin profile  -->
		<v-list-item link v-if="$store.state.user_type==$keys.SUPER_ADMIN" >
			<v-list-item-content>
				<div class="text-center">
						<p class="text-center drawer-text">
						{{$keys.SUPER_ADMIN}}
					</p>
				</div>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</v-navigation-drawer>
</div>
</template>
<script>
import { mapGetters } from 'vuex';


export default {
	components:{

	},
	data () {
		return {
			drawer: false,
			warehouse:null,
			loading:false,	
			warehouse_list:[],
			warehouse_serch_query:"",
		}
	},
	computed: mapGetters({
		getDrawerItems: 'drawer/getDrawerItems',
		getManageTab: 'drawer/getManageTab',
		getSubDrawerItems: 'secondary_drawer/getDrawerItems'
	}),
	created(){
		console.log('$store.state.primary_drawer')
		console.log(this.$store.state.drawer.primary_drawer)
		this.$store.dispatch('drawer/setActiveTab',localStorage.getItem("active-tab"))

		if (this.$store.state.warehouse)
			this.warehouse=this.$store.state.warehouse
		else{
			setTimeout(()=>{
				this.warehouseAutoComplete()
			},500);
		}
	},
	mounted(){
		this.warehouseAutoComplete()
	},
	methods:{
		setActiveTab(item){
			console.log(item)
			this.$store.dispatch('drawer/setActiveTab',item.url.name)
		},
		logout(){
			localStorage.removeItem("active-tab"); 
					// sessionStorage.removeItem("token"); 
					sessionStorage.clear() ;
					if(this.$store.state.user_type==this.$keys.WHOLESALER)
						this.$router.push({name:'wholesaler-login'})
					else
						this.$router.push({name:'warehouse-login'})
				},
				updateWarehouse(){
					console.log(this.warehouse)
					this.$store.dispatch('setWarehouse',this.warehouse)
					localStorage.setItem('warehouse', JSON.stringify(this.warehouse));
					location.reload()
				},
				warehouseAutoComplete(){
					const self=this
					let params={
						"search_query":self.warehouse_serch_query,
					};
					self.loading=true;
					const successHandler = (response) => {
						console.log(response)
						self.warehouse_list=response.data.warehouse_list

						if (!this.warehouse){
							let warehouse=response.data.warehouse_list[0]
							this.warehouse=warehouse
							localStorage.setItem('warehouse', JSON.stringify(warehouse));

							this.$store.dispatch('setWarehouse',warehouse)

						}


					};
					const finallyHandler = () => {
						self.loading=false
					};
					self.request_GET( self,self.$urls.WAREHOUSE_LIST,params,successHandler,null,null,finallyHandler)


				}


			}
		}
</script>